export default __webpack_public_path__ + "static/media/kathy_wu.1b1a12dc.jpg";